import jwt from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { IAuth } from '../../../types';

export const useLoginFunctions = (
  loginType?: 'phoneNumber' | 'email',
  checkForPassword?: boolean
) => {
  const { t } = useTranslation();

  const LoginFormValidationSchema: yup.SchemaOf<IAuth.ILoginSchema> = yup
    .object()
    .shape({
      identifier: yup
        .string()
        .required(t('this-field-is-required'))
        .nullable(false),
      password:
        loginType === 'phoneNumber' && !checkForPassword
          ? yup.string()
          : yup.string().required(t('this-field-is-required')),
      country: yup.string(),
    });

  const LoginInvitationValidationSchema: yup.SchemaOf<IAuth.ILoginSchema> = yup
    .object()
    .shape({
      identifier: yup
        .string()
        .required(t('this-field-is-required'))
        .nullable(false),
      password: yup
        .string()
        .required(t('this-field-is-required'))
        .test(
          'password-strength',
          t('password-must-match-requirements'),
          function (value) {
            if (!value) {
              return false;
            }
            const hasMinLength = value?.length >= 8;
            const hasNumber = /\d/.test(value || '');
            const hasLetter = /[a-zA-Z]/.test(value || '');

            return hasMinLength && hasNumber && hasLetter;
          }
        ),
      country: yup.string().optional(),
    });

  const OTPValidationSchema: yup.SchemaOf<{ code: string }> = yup
    .object()
    .shape({
      code: yup.string().required(t('this-field-is-required')),
    });

  const convertJWT = (
    token: string
  ): IAuth.ILoginInvitationUserData | undefined => {
    const secretKey = process.env.NEXT_PUBLIC_JWT_KEY;
    if (secretKey && token) {
      const decoded = jwt.decode(token.replace(/\?/g, ''));

      return decoded as IAuth.ILoginInvitationUserData | undefined;
    }
    return undefined;
  };

  return {
    convertJWT,
    LoginFormValidationSchema,
    LoginInvitationValidationSchema,
    OTPValidationSchema,
  };
};
